export default "__VITE_ASSET__DCfFnzOd__"